import Skeleton from "react-loading-skeleton";
import { HiShoppingCart } from "react-icons/hi";
import ResponsiveCDNImage from "../../../components/common/image/responsive-cdn-image";
import BACK_IMG from "../../../components/common/back-img.png";
import type { ProductQuery } from "../../../__generated__/graphql";

type Product = ProductQuery["product"];

interface ProductImageSectionProps {
  product: Product | null | undefined;
  loading: boolean;
  cartQuantityInCart: number;
  onBack: () => void;
}

const ProductImageSection = ({
  product,
  loading,
  cartQuantityInCart,
  onBack,
}: ProductImageSectionProps) => {
  const hasMenus = product?.menus && product.menus.length > 0;
  const singleImageSrc =
    ((product?.img as string) || product?.menus?.[0]?.img) ?? "";

  return (
    <div className="relative w-full">
      <img
        src={BACK_IMG}
        alt="back"
        onClick={onBack}
        className="absolute top-5 left-5 w-[40px] h-[40px] z-10"
      />
      <div className="flex overflow-scroll">
        {loading && (
          <Skeleton
            style={{ height: 240, width: "100vw", lineHeight: 2 }}
          />
        )}
        {hasMenus ? (
          <div className="flex p-2 gap-2">
            {!loading &&
              [...(product?.menus ?? [])].reverse().map((menu) => (
                <div
                  key={menu.id}
                  className="relative w-60 h-60 rounded-lg overflow-hidden"
                >
                  <ResponsiveCDNImage
                    src={menu.img || ""}
                    alt="menu"
                    className="w-60 h-60 object-cover"
                  />
                  {cartQuantityInCart > 0 && (
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-10">
                      <HiShoppingCart className="text-[#1569fc] text-5xl" />
                      <span className="text-white text-lg font-bold mt-1">
                        x {cartQuantityInCart}
                      </span>
                    </div>
                  )}
                  {menu.menu?.description ? (
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-70 text-white p-2 flex items-center justify-between">
                      <p className="text-xs font-semibold line-clamp-2 flex-1 mr-2">
                        {menu.menu.description}
                      </p>
                      <div className="rounded-md opacity-90 bg-black px-2 py-1 shrink-0">
                        <p className="text-sm font-semibold">
                          x{menu.quantity}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="absolute bottom-2 right-2 rounded-md opacity-80 bg-black text-white p-2 px-2.5">
                      <p className="text-lg font-semibold">
                        x{menu.quantity}
                      </p>
                    </div>
                  )}
                </div>
              ))}
          </div>
        ) : (
          <div className="relative w-full h-56">
            <ResponsiveCDNImage
              src={singleImageSrc}
              alt="Product"
              className="object-cover w-full h-56"
              sizeRatio={0.5}
            />
            {cartQuantityInCart > 0 && (
              <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-10">
                <HiShoppingCart className="text-[#1569fc] text-5xl" />
                <span className="text-white text-lg font-bold mt-1">
                  x {cartQuantityInCart}
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductImageSection;
